import { render, staticRenderFns } from "./dangBuilding.vue?vue&type=template&id=2cd66c1e&scoped=true"
import script from "./dangBuilding.vue?vue&type=script&lang=js"
export * from "./dangBuilding.vue?vue&type=script&lang=js"
import style0 from "./dangBuilding.vue?vue&type=style&index=0&id=2cd66c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd66c1e",
  null
  
)

export default component.exports